// Reconstructed from the published NovaVP application; original names unavailable where not recovered.
import { Fragment } from "react";
import * as React from "react";
import { isLanguage } from "./i18n.jsx";
var themeLabels = {
  fr: {
    dark: `Mode sombre`,
    light: `Mode clair`,
  },
  en: {
    dark: `Dark mode`,
    light: `Light mode`,
  },
  es: {
    dark: `Modo oscuro`,
    light: `Modo claro`,
  },
  de: {
    dark: `Dunkler Modus`,
    light: `Heller Modus`,
  },
  it: {
    dark: `Modalità scura`,
    light: `Modalità chiara`,
  },
  nl: {
    dark: `Donkere modus`,
    light: `Lichte modus`,
  },
};
function ThemeToggle() {
  let [e, t] = React.useState(`dark`),
    [n, s] = React.useState(`fr`);
  React.useEffect(() => {
    let e = () => {
        let e = document.documentElement.lang.split(`-`)[0];
        s(isLanguage(e) ? e : `fr`);
      },
      n = new MutationObserver(e);
    (n.observe(document.documentElement, {
      attributes: true,
      attributeFilter: [`lang`],
    }),
      e());
    let i = window.setTimeout(
      () =>
        t(
          document.documentElement.dataset.theme === `light` ? `light` : `dark`,
        ),
      0,
    );
    return () => {
      (window.clearTimeout(i), n.disconnect());
    };
  }, []);
  let c = () => {
      let n = e === `dark` ? `light` : `dark`;
      ((document.documentElement.dataset.theme = n),
        localStorage.setItem(`novavp-theme`, n),
        t(n));
    },
    l = e === `dark` ? `light` : `dark`;
  return (
    <button
      className={`themeToggle`}
      type={`button`}
      onClick={c}
      aria-label={themeLabels[n][l]}
      title={themeLabels[n][l]}
    >
      <span aria-hidden={`true`}>{e === `dark` ? `☀` : `☾`}</span>
      <strong>{themeLabels[n][l]}</strong>
    </button>
  );
}
export { ThemeToggle as default };
